import PropTypes from 'prop-types'
import { memo, useEffect } from 'react'
import { isEmpty, isNullOrUndefinedOrEmpty } from 'utils'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Table from 'components/table/Table'
import { TalkChannelList } from 'features/talkChannelRegister/TalkChannelList'
import {
  setKakaoTalkChannelsFromOldData,
  toggleTalkChannel,
} from 'features/channel/add/channelAddSlice'
import usePrevious from 'utils/hooks/usePrevious'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import ErrorText from '../../../../components/form/ErrorText'
import fetchTalkChannels from '../thunk/fetchTalkChannels'

const { REACT_APP_PF_HOST } = process.env

const TalkChannel = memo(({ error, isEditable }) => {
  const dispatch = useDispatch()

  const { kakaoTalkChannels, oldKakaoTalkChannels } = useSelector(
    state => state.channel.channelAdd,
    shallowEqual
  )

  const prevOldKakaoTalkChannels = usePrevious(oldKakaoTalkChannels)
  const prevKakaoTalkChannels = usePrevious(kakaoTalkChannels)

  useEffect(() => {
    dispatch(fetchTalkChannels())
  }, [dispatch])

  useEffect(() => {
    if (
      !isNullOrUndefinedOrEmpty(prevOldKakaoTalkChannels) &&
      !isNullOrUndefinedOrEmpty(prevKakaoTalkChannels)
    )
      return
    if (
      isNullOrUndefinedOrEmpty(kakaoTalkChannels) ||
      isNullOrUndefinedOrEmpty(oldKakaoTalkChannels)
    )
      return
    dispatch(setKakaoTalkChannelsFromOldData())
  }, [
    dispatch,
    kakaoTalkChannels,
    oldKakaoTalkChannels,
    prevKakaoTalkChannels,
    prevOldKakaoTalkChannels,
  ])

  const handleToggleChannel = uuid => dispatch(toggleTalkChannel(uuid))

  return (
    <Table.Row className="tr_connect" error={error}>
      <th scope="row">
        <div className="inner_tbl">
          카카오톡 채널
          <div />
        </div>
      </th>
      <td>
        {isEmpty(kakaoTalkChannels) ? (
          <div className="inner_tbl">
            <div className="item_tit">
              <strong className="tit_detail">
                연동 가능한 카카오톡 채널이 없습니다.
              </strong>
            </div>
            <a
              href={REACT_APP_PF_HOST}
              target="_blank"
              className="btn_gm gm_bl"
              rel="noopener noreferrer">
              <span className="inner_g">카카오톡 채널 만들기</span>
            </a>
          </div>
        ) : (
          <div className="inner_tbl">
            <div className="item_tit">
              <strong className="tit_detail">
                카카오톡 채널 연동
                <HelpTooltip>
                  선택한 비즈채널 유형에 따라 필수 여부 및 연동 가능한 개수가
                  구분됩니다.
                  <ul className="list_tooltip">
                    <li>
                      <span className="ico_dot"></span>비즈채널 유형: 웹사이트 →
                      최대 2개까지 연동 가능 (선택사항)
                    </li>
                    <li>
                      <span className="ico_dot"></span>비즈채널 유형: 카카오톡
                      채널 → 1개만 연동 가능 (필수사항)
                    </li>
                  </ul>
                </HelpTooltip>
              </strong>
            </div>
            <TalkChannelList
              isEditable={isEditable}
              kakaoTalkChannels={kakaoTalkChannels}
              handleToggleChannel={handleToggleChannel}
              error={error}
            />
            <ErrorText error={error} />
          </div>
        )}
      </td>
    </Table.Row>
  )
})

export default TalkChannel
TalkChannel.displayName = 'TalkChannel'
TalkChannel.propTypes = {
  error: PropTypes.string,
  isEditable: PropTypes.bool,
}
